import { Quill } from '@/plugins/quilljs';

const Inline = Quill.import('blots/inline');

class SearchedStringBlot extends Inline {
  static create({ index, selected }) {
    const node = super.create(index);
    node.contentEditable = 'false';
    node.dataset.index = index;
    if (selected) {
      node.dataset.selected = '';
    }
    return node;
  }
}

SearchedStringBlot.blotName = 'searchedString';
SearchedStringBlot.className = 'ql-searched-string';
SearchedStringBlot.tagName = 'div';

export default SearchedStringBlot;
